module.exports = __webpack_public_path__ + "static/esco-12-7501a3b21d3e00bf695a0242eb70d727.jpeg";